import React from 'react';
import ReactDOM from 'react-dom';

import usePortalPosition from './usePortalPosition';

/**
 * The label shown beside a collapsed rail icon on hover. Portalled for the
 * same reason as SidebarPopover, and driven entirely by the shared hover
 * state so it vanishes the instant the rail expands and real labels appear.
 *
 * @param {boolean} props.open
 * @param {object} props.anchorRef
 * @param {string} props.id Referenced by the anchor's aria-describedby.
 * @param {node} props.children Label text.
 */
const RailTooltip = ({
  open, anchorRef, id, children,
}) => {
  const position = usePortalPosition(anchorRef, open, 10);

  if (!open || !position || typeof document === 'undefined') return null;

  return ReactDOM.createPortal(
    <span
      id={id}
      role="tooltip"
      style={{top: position.top, left: position.left}}
      className="pointer-events-none fixed z-40 flex h-10 items-center rounded-md bg-gray-900 px-2.5 text-xs font-medium whitespace-nowrap text-white shadow-lg motion-safe:animate-in motion-safe:fade-in motion-safe:duration-100"
    >
      {children}
    </span>,
    document.body,
  );
};

export default RailTooltip;
